import React, { Fragment, Component } from 'react'
import PropTypes from 'prop-types'
import Address from 'components/Address'
import {
  UNIT_NUMBER_KEY,
  UNIT_TYPE_KEY,
  STREET_NUMBER_KEY,
  STREET_NAME_KEY,
  STREET_TYPE_KEY,
  SUBURB_KEY,
  STATE_KEY,
  POSTCODE_KEY,
} from 'components/Address/constants'
import AutocompleteAddress from 'components/AutocompleteAddress'
import { searchForAddress } from 'components/AutocompleteAddress/actions'
import { ADDRESS_ID_KEY, ADDRESS_TEXT_KEY } from 'components/AutocompleteAddress/constants'

class AddressForm extends Component {
  static propTypes = {
    manual: PropTypes.bool,
    loading: PropTypes.bool,
    onFieldUpdated: PropTypes.func,
    onAddressSelected: PropTypes.func,
    onManualEntry: PropTypes.func,
    gaCategory: PropTypes.string,
    fieldValues: PropTypes.shape({
      [UNIT_NUMBER_KEY]: PropTypes.string,
      [UNIT_TYPE_KEY]: PropTypes.string,
      [STREET_NUMBER_KEY]: PropTypes.string,
      [STREET_NAME_KEY]: PropTypes.string,
      [STREET_TYPE_KEY]: PropTypes.string,
      [SUBURB_KEY]: PropTypes.string,
      [STATE_KEY]: PropTypes.string,
      [POSTCODE_KEY]: PropTypes.string,
      [ADDRESS_ID_KEY]: PropTypes.string,
      [ADDRESS_TEXT_KEY]: PropTypes.string,
    }),

    fieldErrors: PropTypes.object,
  }

  static defaultProps = {
    manual: false,
    loading: false,
    onFieldUpdated: f => f,
    onAddressSelected: f => f,
    onManualEntry: f => f,
    gaCategory: '',
    fieldValues: {
      [UNIT_NUMBER_KEY]: '',
      [UNIT_TYPE_KEY]: '',
      [STREET_NUMBER_KEY]: '',
      [STREET_NAME_KEY]: '',
      [STREET_TYPE_KEY]: '',
      [SUBURB_KEY]: '',
      [STATE_KEY]: '',
      [POSTCODE_KEY]: '',
      [ADDRESS_ID_KEY]: '',
      [ADDRESS_TEXT_KEY]: '',
    },
    fieldErrors: {
      [UNIT_NUMBER_KEY]: '',
      [UNIT_TYPE_KEY]: '',
      [STREET_NUMBER_KEY]: '',
      [STREET_NAME_KEY]: '',
      [STREET_TYPE_KEY]: '',
      [SUBURB_KEY]: '',
      [STATE_KEY]: '',
      [POSTCODE_KEY]: '',
      [ADDRESS_ID_KEY]: '',
      [ADDRESS_TEXT_KEY]: '',
    },
  }

  constructor(props) {
    super(props)
    this.focusRef = React.createRef()
  }

  focus = () => {
    this.focusRef.current.focus()
  }

  search = address => this.focusRef.current.handleSearchDebounced(address)

  render() {
    const {
      manual,
      loading,
      fieldValues,
      fieldErrors,
      onAddressSelected,
      onFieldUpdated,
      onManualEntry,
      gaCategory,
    } = this.props

    const autoCompleteValue = fieldValues[ADDRESS_TEXT_KEY]
    const autoCompleteError = fieldErrors[ADDRESS_TEXT_KEY]

    return (
      <Fragment>
        { manual ?
          <Address
            ref={this.focusRef}
            fieldValues={fieldValues}
            fieldErrors={fieldErrors}
            loading={loading}
            onFieldUpdated={onFieldUpdated}
          />
          :
          <AutocompleteAddress
            ref={this.focusRef}
            value={autoCompleteValue}
            loading={loading}
            errorMessage={autoCompleteError}
            onManualEntry={onManualEntry}
            onSelect={onAddressSelected}
            searchForAddress={searchForAddress}
            gaCategory={gaCategory}
          />
        }
      </Fragment>
    )
  }
}

export default AddressForm



// WEBPACK FOOTER //
// ./components/AddressForm/index.jsx